import { DataCenter, DataCenterAttribute, NotSupportedValueError } from '@bimone/bimtrack-core';
import { HubRegionSummaryDto } from './types';

const CANADA_EAST = 'CanadaEast';
const LOCAL = 'CanadaEastLocal';
const EUROPE = 'Europe';
const NORTH_EUROPE = 'NorthEurope';
const US_EAST = 'USEast';

class DataCentersAssembler {
  public toDomain(dto: HubRegionSummaryDto): DataCenterAttribute {
    return new DataCenterAttribute({ id: DataCentersAssembler.getDataCenterIdFromLocation(dto.Location) });
  }

  private static getDataCenterIdFromLocation(location: string): DataCenter {
    switch (location) {
      case LOCAL:
        return DataCenter.LOCAL;
      case CANADA_EAST:
        return DataCenter.CANADA;
      case EUROPE:
        return DataCenter.EUROPE;
      case NORTH_EUROPE:
        return DataCenter.NORTH_EUROPE;
      case US_EAST:
        return DataCenter.USA;
      default:
        throw new NotSupportedValueError();
    }
  }
}

export default new DataCentersAssembler();
